/**
 * Built-in plugin: surfaces reference health (broken refs, router links).
 */

import { registerPlugin } from "../types";
import type { Skill } from "../../types";
import { createElement } from "react";

registerPlugin({
  id: "reference-health",
  name: "Reference Health",
  description: "Tracks broken references and router link integrity.",
  enrich(skill: Skill) {
    return {
      ...skill,
      refHealth: skill.brokenRefs.length === 0
        ? "ok"
        : skill.brokenRefs.length <= 2 ? "warn" : "bad",
    };
  },
  facets(skill: Skill) {
    const h = skill.brokenRefs.length === 0 ? "ok" : skill.brokenRefs.length <= 2 ? "warn" : "bad";
    return { refHealth: h };
  },
  facetFilters: [
    {
      id: "refOk",
      label: "Ref health · OK",
      match: (s) => s.refHealth === "ok" || (s.refHealth === undefined && s.brokenRefs.length === 0),
    },
    {
      id: "refWarn",
      label: "Ref health · Warn",
      match: (s) => s.refHealth === "warn",
    },
    {
      id: "refBad",
      label: "Ref health · Bad",
      match: (s) => s.refHealth === "bad",
    },
  ],
  DetailSection({ skill }) {
    if (!skill.hasRefs) {
      return createElement("div", { className: "font-mono text-[11px] text-muted font-medium py-1" }, "// No references defined");
    }
    const color = skill.refHealth === "ok" ? "text-good" : skill.refHealth === "warn" ? "text-warn" : "text-bad";
    return createElement("div", { className: "flex flex-col gap-2 font-mono text-[11px] mt-1" }, [
      createElement("div", { key: "count", className: "flex justify-between border-b border-rule py-1.5" },
        createElement("span", {}, "References:"),
        createElement("span", { className: "font-bold tabular-nums" }, skill.referenceCount)
      ),
      createElement("div", { key: "status", className: "flex justify-between border-b border-rule py-1.5" },
        createElement("span", {}, "Status:"),
        createElement("span", { className: `font-bold uppercase ${color}` }, skill.refHealth?.toUpperCase())
      ),
      skill.brokenRefs.length > 0
        ? createElement("div", { key: "broken", className: "py-1.5 text-bad flex flex-col gap-1" }, [
            createElement("span", { className: "font-bold" }, "Broken refs:"),
            skill.brokenRefs.map((ref, idx) =>
              createElement("span", { key: idx, className: "pl-2 truncate" }, `• ${ref}`)
            ),
          ])
        : null
    ]);
  }
});
